export default "__VITE_ASSET__ChHccdeF__"